export default "__VITE_ASSET__DENBj0V2__"